import { useEffect, type ReactNode } from "react";
/** Modal del sistema (sk-modal); el posicionamiento (pos-dialog) es page-layout de la app. */
export function Modal({ open, title, subtitle, onClose, children, footer, className }: { open: boolean; title: ReactNode; subtitle?: ReactNode | undefined; onClose: () => void; children: ReactNode; footer?: ReactNode | undefined; className?: string | undefined }) {
  useEffect(() => {
    if (!open) return;
    const esc = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", esc);
    return () => document.removeEventListener("keydown", esc);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className={className} role="dialog" aria-modal="true">
      <div className="sk-modal" style={{ boxShadow: "var(--sk-shadow-2)" }}>
        <h2 className="sk-h2">{title}</h2>
        {subtitle !== undefined && <p className="sk-modal-sub">{subtitle}</p>}
        {children}
        {footer !== undefined && <div className="sk-modal-foot">{footer}</div>}
      </div>
    </div>
  );
}
